import React, { useState, useEffect } from 'react';
import MonitoringRatesComponent from './MonitoringRates/MonitoringRatesComponent/MonitoringRatesComponent';

export default function CampaignHealthMonitoring() {
  
    document.title = 'Campaign Health Monitoring Dashboard';

    return (                    
        <React.Fragment>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1 d-flex align-items-center">
                    <div>Campaign Health Monitoring Dashboard</div>
                </h1>
            </div>
            <div className="row">
            <div className="col-lg-12">
                <div className="row">
                    <div className="col-lg-5">
                        <MonitoringRatesComponent />
                    </div>
                    <div className="col-lg-4">
                    </div>
                    <div className="col-lg-3">

                    </div>
                </div>
            </div>
            <div className="col-lg-4">

            </div>
        </div>
        </React.Fragment>
    )

}